import React from 'react';
import { useTranslation } from 'next-i18next';
import { Tooltip } from '@mui/material';
import { Beta } from './DentalIQBeta.styles';
export const DentalIQBeta = ({
  tooltipPlacement
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Tooltip, {
    placement: tooltipPlacement,
    title: t('b2c.dentalIQ.beta.tooltip'),
    arrow: true
  }, /*#__PURE__*/React.createElement(Beta, null, t('b2c.dentalIQ.beta.label')));
};